import { useEffect, useState } from "react";
import "./DebtorForm.scss";
import { MotifIcon, MotifProgressLoader } from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Banner, { BannerElement } from "@/components/Banner/Banner";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import TabPanel from "@/components/TabPanel/TabPanel";
import DebtorForm from "./DebtorForm";
import { useGetDebtorEditViewApiDataQuery } from "@/services/debtors/debtorsReducers";
import ClaimTabContent from "@/features/debtor/claimsTab/claimsTabContent";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useCase } from "@/features/case/use-case";
import { skipToken } from "@reduxjs/toolkit/query";
import { ActiveTabsOrder } from "@/menuData";
import { useDispatch } from "react-redux";
import { setRetainDebtorId } from "@/features/retain_state/retainStateSlice";
const DebtorFormGrid = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId, editId } = useParams();
  const caseData = useCase(caseId);
  const editView = editId ? true : false;
  const { data, isLoading } = useGetDebtorEditViewApiDataQuery(
    editId || skipToken,
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const [isDiscardVisible, setIsDiscardVisible] = useState(false);
  const debtorData = data ? data : {};
  const dispatch= useDispatch();
  useEffect(()=>{
   dispatch(setRetainDebtorId({debtorId:editId}))
  },[dispatch,editId])
  interface BannerData {
    totalClaims: string;
    name: string;
  }

  const bannerData: BannerData = {
    totalClaims: data?.totalClaims ? data?.totalClaims.toString() : "",
    name: data?.name || "",
  };
  const debtorBanner = {
    debtorTtl: "pages.debtors.debtorBannerDetails.debtor",
    debtorName: bannerData.name,
  };

  const bannerElements: BannerElement[] = [
    {
      label: "pages.debtors.debtorBannerDetails.totalClaims",
      value: bannerData.totalClaims,
      elementKey: "caseID",
    },
  ];

  const tabPanelData = {
    title: [
      "pages.debtors.debtorTabPanelDetails.summary",
      "pages.debtors.debtorTabPanelDetails.claims",
    ],
    content: [
      <DebtorForm debtorData={{ editView: editView, ...debtorData }} />,
      <div className="ccwp_table_wrapper">
        <ClaimTabContent debtorData={debtorData} />
      </div>,
    ],
  };
  const breadcrumbItems = editView
    ? [
        {
          label: "External Submission",
          value: "10 New Creditor Submission",
          elementKey: "submission",
          text: caseData?.caseName || t("global.globalActions.backToCase"),
          url: `/case/${caseData?.caseId}?activeTab=${ActiveTabsOrder.DEBTOR}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          label: "External Submission",
          value: "10 New Creditor Submission",
          elementKey: "submission",
          text: debtorBanner.debtorName,
          url: "/",
          disabled: true,
        },
      ]
    : [
        {
          label: "External Submission",
          value: "10 New Creditor Submission",
          elementKey: "submission",
          text: caseData?.caseName || t("global.globalActions.backToCase"),
          url: `/case/${caseData?.caseId}?activeTab=${ActiveTabsOrder.DEBTOR}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
        },
        {
          label: "External Submission",
          value: "10 New Creditor Submission",
          elementKey: "submission",
          text: t("pages.debtors.debtorCreate"),
          url: `/case/${caseData?.caseId}?activeTab=${ActiveTabsOrder.DEBTOR}`,
          icon: <MotifIcon src={IconoirArrowLeft} />,
          disabled: true,
        },
      ];

  const defaultDebtorData = {
    debtorId: "97a19c21-0870-44fa-aea1-6d2e42f51076",
    caseId: "",
    name: "",
    description: "",
    createdBy: "CA013334848",
    updatedBy: "CA013334848",
    isActive: true,
    editView: false,
  };

  if (!editView) {
    return (
      <>
        <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
        <DebtorForm debtorData={defaultDebtorData} />
        <ConfirmationModal
          isVisible={isDiscardVisible}
          setIsVisible={setIsDiscardVisible}
          cancelBtnApproveHandler={() => {
            navigate(`/case/${caseId}?activeTab=${ActiveTabsOrder.DEBTOR}`);
          }}
          cancelBtnRejectHandler={() => setIsDiscardVisible(false)}
        />
      </>
    );
  }

  if (isLoading) {
    return <MotifProgressLoader />;
  }

  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      <Banner
        bannerName={debtorBanner.debtorTtl}
        bannerNameValue={debtorBanner.debtorName}
        elements={bannerElements}
      />
      <div className="ccwp_table_tabpanel">
        <TabPanel data={tabPanelData} defaultActiveKey={0} />
      </div>
    </>
  );
};

export default DebtorFormGrid;
